import React, { useEffect, useState } from 'react';
import TabWrapper from './TabWrapper';
import { getListBountyByDao } from 'redux/actions/daoUI/bounty.action';
import BountyDetailModal from './BountyDetailModal';

const BountyTab = ({ daoOrganizerAddress, daoId, chainId }) => {
  const [bounties, setBounties] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(0);
  const [openDetail, setOpenDetail] = useState(false);
  const [selectedBounty, setSelectedBounty] = useState(null);
  const [isCreateMode, setIsCreateMode] = useState(false);

  useEffect(() => {
    const fetchBounties = async () => {
      setLoading(true);
      setError(null);
      try {
        const params = {
          daoId,
          chainId,
          page,
          limit
        };
        const data = await getListBountyByDao(params)();
        setBounties(data?.data || []);
        setTotal(data?.pagination?.total || 0);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };
    if (daoOrganizerAddress && chainId) fetchBounties();
  }, [daoOrganizerAddress, chainId, page, limit]);

  const handleCreateNew = () => {
    setIsCreateMode(true);
    setSelectedBounty(null);
    setOpenDetail(true);
  };

  const handleCloseModal = () => {
    setOpenDetail(false);
    setIsCreateMode(false);
    setSelectedBounty(null);
  };

  const reloadBounties = () => {
    setPage(1); // Reset về trang 1
    const params = {
      daoId,
      chainId,
      page: 1,
      limit
    };
    getListBountyByDao(params)()
      .then(data => {
        setBounties(data?.data || []);
        setTotal(data?.pagination?.total || 0);
      })
      .catch(err => {
        setError(err);
      });
  };

  return (
    <TabWrapper daoOrganizerAddress={daoOrganizerAddress} chainId={chainId}>
      {loading && <div>Loading...</div>}
      {error && <div style={{ color: 'red' }}>{error}</div>}
      {!loading && !error && (
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
            <h3 style={{ color: '#03edc3' }}>Bounty List</h3>
            <button 
              onClick={handleCreateNew}
              style={{
                padding: '8px 16px',
                backgroundColor: '#00ffe0',
                color: '#181c22',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontWeight: 'bold'
              }}
            >
              Create New Bounty
            </button>
          </div>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: 0, marginTop: '20px', background: '#23272f', color: '#00ffe0', borderRadius: 8, overflow: 'hidden', boxShadow: '0 2px 8px #0006' }}>
              <thead>
                <tr style={{ backgroundColor: '#181c22' }}>
                  <th style={{ padding: '14px', textAlign: 'left', borderBottom: '2px solid #00ffe0', color: '#00ffe0', fontWeight: 600 }}>Name</th>
                  <th style={{ padding: '14px', textAlign: 'left', borderBottom: '2px solid #00ffe0', color: '#00ffe0', fontWeight: 600 }}>Registration Close Date</th>
                  <th style={{ padding: '14px', textAlign: 'left', borderBottom: '2px solid #00ffe0', color: '#00ffe0', fontWeight: 600 }}>Submission Deadline</th>
                  <th style={{ padding: '14px', textAlign: 'left', borderBottom: '2px solid #00ffe0', color: '#00ffe0', fontWeight: 600 }}>Closed Date</th>
                  <th style={{ padding: '14px', textAlign: 'left', borderBottom: '2px solid #00ffe0', color: '#00ffe0', fontWeight: 600 }}>Status</th>
                </tr>
              </thead>
              <tbody>
                {bounties.map((bounty, idx) => (
                  <tr key={bounty._id}
                    style={{ borderBottom: '1px solid #00ffe0', background: idx % 2 === 0 ? '#23272f' : '#181c22', transition: 'background 0.2s', cursor: 'pointer' }}
                    onMouseOver={e => e.currentTarget.style.background = '#26313a'}
                    onMouseOut={e => e.currentTarget.style.background = idx % 2 === 0 ? '#23272f' : '#181c22'}
                    onClick={() => { setSelectedBounty(bounty); setOpenDetail(true); }}
                  >
                    <td style={{ padding: '12px', color: '#fff' }}>{bounty.name}</td>
                    <td style={{ padding: '12px', color: '#fff' }}>{bounty.startDate ? new Date(bounty.startDate).toLocaleDateString() : 'Not specified'}</td>
                    <td style={{ padding: '12px', color: '#fff' }}>{bounty.endDate ? new Date(bounty.endDate).toLocaleDateString() : 'Not specified'}</td>
                    <td style={{ padding: '12px', color: '#fff' }}>{bounty.closedDate ? new Date(bounty.closedDate).toLocaleDateString() : 'Not specified'}</td>
                    <td style={{ padding: '12px', color: '#00ffe0', fontWeight: 600 }}>{bounty.status}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div style={{ marginTop: '20px' }}>
            <button 
              onClick={() => setPage(p => Math.max(1, p - 1))}
              disabled={page === 1}
              style={{
                padding: '8px 16px',
                backgroundColor: '#00ffe0',
                color: '#181c22',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontWeight: 'bold',
                marginRight: '10px',
                opacity: page === 1 ? 0.5 : 1
              }}
            >
              Previous Page
            </button>
            <span style={{ margin: '0 10px', color: '#fff' }}>Page {page}</span>
            <button 
              onClick={() => setPage(p => p + 1)}
              disabled={page >= Math.ceil(total / limit)}
              style={{
                padding: '8px 16px',
                backgroundColor: '#00ffe0',
                color: '#181c22',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontWeight: 'bold',
                opacity: page >= Math.ceil(total / limit) ? 0.5 : 1
              }}
            >
              Next Page
            </button>
          </div>
          <BountyDetailModal 
            open={openDetail} 
            onClose={handleCloseModal} 
            bounty={selectedBounty}
            isCreateMode={isCreateMode}
            daoId={daoId}
            onSuccess={reloadBounties}
          />
        </div>
      )}
    </TabWrapper>
  );
};

export default BountyTab;
